import { Union, Record } from "../fable_modules/fable-library-js.4.29.0/Types.js";
import { ProductModule_outputQuality, ProductModule_normalizedPriceByQuality, ProductModule_normalizedPrice, ProductModule_priceByQuality, ProductModule_price, ProductModule_priceAndQuality, ItemModule_priceByQuality, ItemModule_price, ProductModule_processor, MultipliersModule_common, Multipliers_$reflection, Product, ProcessedItem_$reflection, Item_$reflection } from "./Items.js";
import { bool_type, union_type, string_type, record_type, uint32_type, array_type } from "../fable_modules/fable-library-js.4.29.0/Reflection.js";
import { Table$2, Table_addAll, Table_tryFind, Table$2_$reflection } from "./Prelude.js";
import { CropModule_xpPerHarvest, CropModule_xpItemsPerHarvest, CropModule_xpPerItem, ForageCropModule_xpItemsPerHarvest, CropAmountModule_expectedQuantityByQuality, CropAmountModule_expectedGiantQuantityByQuality, CropAmountModule_expectedQuantity, CropAmountModule_expectedGiantQuantity, ForageCropModule_seedRecipeUnlocked, CropAmountModule_noGiantCropProb, CropModule_growthStagesAndTime, CropModule_paddy, CropModule_growsInSeasons, SeasonModule_seasonsBetween, CropAmountSettingsModule_common, Date$, CropAmountSettings_$reflection, Date$_$reflection, CropModule_mainItem, CropModule_canGetOwnSeedsFromSeedMaker, CropModule_seed, SeedPriceModule_vendor, SeedPrice, Crop, Crop_$reflection, SeedPrice_$reflection, ForageCrop_$reflection, FarmCrop_$reflection } from "./Crops.js";
import { Qualities_zero, Qualities$1, SkillsModule_forageCropHarvestQuantities, SkillsModule_farmCropProbsWith, FertilizerModule_Opt_speed, Profession, SkillsModule_professionActive, SkillsModule_zero, Skills_$reflection, Fertilizer_$reflection } from "./Skills.js";
import { defaultArgWith, defaultArg, toArray, bind, map } from "../fable_modules/fable-library-js.4.29.0/Option.js";
import { getItemFromDict } from "../fable_modules/fable-library-js.4.29.0/MapUtil.js";
import { forAll, filter, choose as choose_1, empty, append as append_1, collect, exists, map as map_1, fold } from "../fable_modules/fable-library-js.4.29.0/Seq.js";
import { fill, item as item_2, updateAt, map as map_2, choose, append } from "../fable_modules/fable-library-js.4.29.0/Array.js";
import { groupBy } from "../fable_modules/fable-library-js.4.29.0/Seq2.js";
import { equals, numberHash } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { max } from "../fable_modules/fable-library-js.4.29.0/Double.js";

export class ExtractedData extends Record {
    constructor(Items, Products, FarmCrops, ForageCrops) {
        super();
        this.Items = Items;
        this.Products = Products;
        this.FarmCrops = FarmCrops;
        this.ForageCrops = ForageCrops;
    }
}

export function ExtractedData_$reflection() {
    return record_type("StardewValleyStonks.ExtractedData", [], ExtractedData, () => [["Items", array_type(Item_$reflection())], ["Products", Table$2_$reflection(uint32_type, array_type(ProcessedItem_$reflection()))], ["FarmCrops", array_type(FarmCrop_$reflection())], ["ForageCrops", array_type(ForageCrop_$reflection())]]);
}

export class SupplementalData extends Record {
    constructor(Fertilizers, FertilizerPrices, GenerateSeedPrices, SeedPrices, ProcessorUnlockLevel) {
        super();
        this.Fertilizers = Fertilizers;
        this.FertilizerPrices = FertilizerPrices;
        this.GenerateSeedPrices = GenerateSeedPrices;
        this.SeedPrices = SeedPrices;
        this.ProcessorUnlockLevel = ProcessorUnlockLevel;
    }
}

export function SupplementalData_$reflection() {
    return record_type("StardewValleyStonks.SupplementalData", [], SupplementalData, () => [["Fertilizers", array_type(Fertilizer_$reflection())], ["FertilizerPrices", Table$2_$reflection(string_type, Table$2_$reflection(string_type, uint32_type))], ["GenerateSeedPrices", Table$2_$reflection(string_type, array_type(uint32_type))], ["SeedPrices", Table$2_$reflection(uint32_type, array_type(SeedPrice_$reflection()))], ["ProcessorUnlockLevel", Table$2_$reflection(string_type, uint32_type)]]);
}

export class GameData extends Record {
    constructor(Fertilizers, FertilizerPrices, Crops, SeedPrices, Seed, Items, Products, ProcessorUnlockLevel) {
        super();
        this.Fertilizers = Fertilizers;
        this.FertilizerPrices = FertilizerPrices;
        this.Crops = Crops;
        this.SeedPrices = SeedPrices;
        this.Seed = Seed;
        this.Items = Items;
        this.Products = Products;
        this.ProcessorUnlockLevel = ProcessorUnlockLevel;
    }
}

export function GameData_$reflection() {
    return record_type("StardewValleyStonks.GameData", [], GameData, () => [["Fertilizers", Table$2_$reflection(string_type, Fertilizer_$reflection())], ["FertilizerPrices", Table$2_$reflection(string_type, Table$2_$reflection(string_type, uint32_type))], ["Crops", Table$2_$reflection(uint32_type, Crop_$reflection())], ["SeedPrices", Table$2_$reflection(uint32_type, Table$2_$reflection(string_type, SeedPrice_$reflection()))], ["Seed", Table$2_$reflection(uint32_type, uint32_type)], ["Items", Table$2_$reflection(uint32_type, Item_$reflection())], ["Products", Table$2_$reflection(uint32_type, Table$2_$reflection(string_type, ProcessedItem_$reflection()))], ["ProcessorUnlockLevel", Table$2_$reflection(string_type, uint32_type)]]);
}

function GameDataModule_implicitProduct(data, item, processor) {
    const itemId = item.Id;
    const matchValue = item.Category;
    let matchResult;
    switch (matchValue.tag) {
        case 2: {
            switch (processor) {
                case "Preserves Jar": {
                    matchResult = 0;
                    break;
                }
                case "Keg": {
                    matchResult = 1;
                    break;
                }
                case "Seed Maker": {
                    matchResult = 4;
                    break;
                }
                default:
                    matchResult = 5;
            }
            break;
        }
        case 1: {
            switch (processor) {
                case "Preserves Jar": {
                    matchResult = 2;
                    break;
                }
                case "Keg": {
                    matchResult = 3;
                    break;
                }
                case "Seed Maker": {
                    matchResult = 4;
                    break;
                }
                default:
                    matchResult = 5;
            }
            break;
        }
        default:
            if (processor === "Seed Maker") {
                matchResult = 4;
            }
            else {
                matchResult = 5;
            }
    }
    switch (matchResult) {
        case 0:
            return new Product(0, [itemId]);
        case 1:
            return new Product(2, [itemId]);
        case 2:
            return new Product(1, [itemId]);
        case 3:
            return new Product(3, [itemId]);
        case 4:
            return map((arg) => (new Product(4, [arg * 1])), Table_tryFind(itemId, data.Seed));
        default:
            return undefined;
    }
}

export function GameDataModule_product(data, processor, item) {
    const matchValue = bind((table_1) => Table_tryFind(processor, table_1), Table_tryFind(item, data.Products));
    if (matchValue == null) {
        return GameDataModule_implicitProduct(data, getItemFromDict(data.Items.fields[0], item), processor);
    }
    else {
        return new Product(5, [matchValue]);
    }
}

export function GameDataModule_products(data, item) {
    const products = Table_tryFind(item, data.Products);
    const item_1 = getItemFromDict(data.Items.fields[0], item);
    return fold((implicit_1, products_1) => append(implicit_1, Array.from(map_1((Item) => (new Product(5, [Item])), products_1.fields[0].values()))), choose((processor) => {
        if (exists((arg10$0040_1) => arg10$0040_1.fields[0].has(processor), toArray(products))) {
            return undefined;
        }
        else {
            return GameDataModule_implicitProduct(data, item_1, processor);
        }
    }, ["Preserves Jar", "Keg", "Seed Maker"]), toArray(products));
}

export function GameDataModule_fromExtractedAndSupplementalData(extracted, supplemental) {
    let seq_14, seq_16, seq_18;
    let items;
    const seq = map_1((v) => [v.Id, v], extracted.Items);
    items = (new Table$2(Table_addAll(new Map([]), seq)));
    let crops;
    const array_3 = map_2((Item_1) => (new Crop(0, [Item_1])), extracted.FarmCrops);
    crops = append(map_2((Item_2) => (new Crop(1, [Item_2])), extracted.ForageCrops), array_3);
    let generatedPrices;
    const seq_2 = map_1((tupledArg_1) => [tupledArg_1[0], map_1((tuple_1) => tuple_1[1], tupledArg_1[1])], groupBy((tuple) => tuple[0], collect((tupledArg) => map_2((seed) => [seed, new SeedPrice(1, [tupledArg[0], undefined])], tupledArg[1]), supplemental.GenerateSeedPrices.fields[0]), {
        Equals: (x, y) => (x === y),
        GetHashCode: numberHash,
    }));
    generatedPrices = (new Table$2(Table_addAll(new Map([]), seq_2)));
    let seedPrices;
    const seq_6 = map_1((k) => {
        let seed_2, seq_4, source_7;
        return [k, (seed_2 = k, (seq_4 = map_1((v_1) => [SeedPriceModule_vendor(v_1), v_1], (source_7 = defaultArg(Table_tryFind(seed_2, supplemental.SeedPrices), new Array(0)), append_1(defaultArg(Table_tryFind(seed_2, generatedPrices), empty()), source_7))), new Table$2(Table_addAll(new Map([]), seq_4))))];
    }, map_1(CropModule_seed, crops));
    seedPrices = (new Table$2(Table_addAll(new Map([]), seq_6)));
    let seeds_1;
    const seq_8 = choose_1((crop) => {
        if (CropModule_canGetOwnSeedsFromSeedMaker((key_5) => getItemFromDict(items.fields[0], key_5), crop)) {
            return [CropModule_mainItem(crop), CropModule_seed(crop)];
        }
        else {
            return undefined;
        }
    }, crops);
    seeds_1 = (new Table$2(Table_addAll(new Map([]), seq_8)));
    let products_1;
    const seq_12 = map_1((tupledArg_2) => {
        let seq_10;
        return [tupledArg_2[0], (seq_10 = map_1((v_2) => [v_2.Processor, v_2], tupledArg_2[1]), new Table$2(Table_addAll(new Map([]), seq_10)))];
    }, extracted.Products.fields[0]);
    products_1 = (new Table$2(Table_addAll(new Map([]), seq_12)));
    return new GameData((seq_14 = map_1((v_3) => [v_3.Name, v_3], supplemental.Fertilizers), new Table$2(Table_addAll(new Map([]), seq_14))), (seq_16 = map_1((k_1) => [k_1, defaultArgWith(Table_tryFind(k_1, supplemental.FertilizerPrices), () => (new Table$2(new Map([]))))], map_1((_arg_8) => _arg_8.Name, supplemental.Fertilizers)), new Table$2(Table_addAll(new Map([]), seq_16))), (seq_18 = map_1((v_4) => [CropModule_seed(v_4), v_4], crops), new Table$2(Table_addAll(new Map([]), seq_18))), seedPrices, seeds_1, items, products_1, supplemental.ProcessorUnlockLevel);
}

export class Location extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Farm", "Greenhouse", "Ginger Island"];
    }
}

export function Location_$reflection() {
    return union_type("StardewValleyStonks.Location", [], Location, () => [[], [], []]);
}

export function LocationModule_growsGiantCrops(_arg) {
    switch (_arg.tag) {
        case 1:
        case 2:
            return false;
        default:
            return true;
    }
}

export function LocationModule_forageCropDestroyFertilizerProb(_arg) {
    switch (_arg.tag) {
        case 0:
        case 1:
            return 0;
        default:
            return 0.1;
    }
}

export class GameVariables extends Record {
    constructor(StartDate, EndDate, Location, Skills, Multipliers, CropAmount, JojaMembership, Irrigated, QualityArtisanProducts) {
        super();
        this.StartDate = StartDate;
        this.EndDate = EndDate;
        this.Location = Location;
        this.Skills = Skills;
        this.Multipliers = Multipliers;
        this.CropAmount = CropAmount;
        this.JojaMembership = JojaMembership;
        this.Irrigated = Irrigated;
        this.QualityArtisanProducts = QualityArtisanProducts;
    }
}

export function GameVariables_$reflection() {
    return record_type("StardewValleyStonks.GameVariables", [], GameVariables, () => [["StartDate", Date$_$reflection()], ["EndDate", Date$_$reflection()], ["Location", Location_$reflection()], ["Skills", Skills_$reflection()], ["Multipliers", Multipliers_$reflection()], ["CropAmount", CropAmountSettings_$reflection()], ["JojaMembership", bool_type], ["Irrigated", bool_type], ["QualityArtisanProducts", bool_type]]);
}

export const GameVariablesModule_common = new GameVariables(new Date$(0, 1), new Date$(3, 28), new Location(0, []), SkillsModule_zero, MultipliersModule_common, CropAmountSettingsModule_common, false, false, false);

export function Game_seasons(vars) {
    return SeasonModule_seasonsBetween(vars.StartDate.Season, vars.EndDate.Season);
}

export function Game_cropIsInSeason(vars, crop) {
    if (!equals(vars.Location, new Location(0, []))) {
        return true;
    }
    else {
        return CropModule_growsInSeasons(Game_seasons(vars), crop);
    }
}

export function Game_inSeasonCrops(vars, crops) {
    let seasons;
    if (equals(vars.Location, new Location(0, []))) {
        return filter((seasons = (Game_seasons(vars) | 0), (_arg) => CropModule_growsInSeasons(seasons, _arg)), crops);
    }
    else {
        return crops;
    }
}

export function Game_growthMultiplier(vars, crop) {
    return (SkillsModule_professionActive(new Profession(2, []), vars.Skills) ? 0.1 : 0) + ((vars.Irrigated && CropModule_paddy(crop)) ? 0.25 : 0);
}

export function Game_growthSpeed(vars, fertilizer, crop) {
    return FertilizerModule_Opt_speed(fertilizer) + Game_growthMultiplier(vars, crop);
}

export function Game_growthTimeAndStages(vars, fertilizer, crop) {
    return CropModule_growthStagesAndTime(Game_growthSpeed(vars, fertilizer, crop), crop);
}

export function Game_growthTime(vars, fertilizer, crop) {
    return Game_growthTimeAndStages(vars, fertilizer, crop)[1];
}

export function Game_giantCropProb(vars) {
    if (LocationModule_growsGiantCrops(vars.Location)) {
        return 1 - CropAmountModule_noGiantCropProb(vars.CropAmount);
    }
    else {
        return 0;
    }
}

export function Game_farmCropDestroyFertilizerProb(vars, crop) {
    if (crop.Giant && LocationModule_growsGiantCrops(vars.Location)) {
        return 0.1 * (1 - CropAmountModule_noGiantCropProb(vars.CropAmount));
    }
    else {
        return 0;
    }
}

export function Game_destroyFertilizerProb(vars, _arg) {
    if (_arg.tag === 1) {
        return LocationModule_forageCropDestroyFertilizerProb(vars.Location);
    }
    else {
        return Game_farmCropDestroyFertilizerProb(vars, _arg.fields[0]);
    }
}

export function Game_forageCropSeedRecipeUnlocked(vars, crop) {
    if (vars.Skills.IgnoreSkillLevelRequirements) {
        return true;
    }
    else {
        return ForageCropModule_seedRecipeUnlocked(vars.Skills, crop);
    }
}

export function Game_farmCropMainItemQuantity(vars, crop) {
    if (crop.Giant && LocationModule_growsGiantCrops(vars.Location)) {
        return CropAmountModule_expectedGiantQuantity(vars.Skills, vars.CropAmount, crop.Amount);
    }
    else {
        return CropAmountModule_expectedQuantity(vars.Skills, vars.CropAmount, crop.Amount);
    }
}

export function Game_farmCropMainItemQuantityByQuality(vars, fertilizer, crop) {
    const qualities = SkillsModule_farmCropProbsWith(fertilizer, vars.Skills);
    if (crop.Giant && LocationModule_growsGiantCrops(vars.Location)) {
        return CropAmountModule_expectedGiantQuantityByQuality(vars.Skills, vars.CropAmount, crop.Amount, qualities);
    }
    else {
        return CropAmountModule_expectedQuantityByQuality(vars.Skills, vars.CropAmount, crop.Amount, qualities);
    }
}

export function Game_forageCropItemQuantityByQuality(vars, crop) {
    return new Qualities$1(map_2((a) => (a / crop.Foragables.length), SkillsModule_forageCropHarvestQuantities(vars.Skills).fields[0], Float64Array));
}

export function Game_farmCropItemQuantitiesByQuality(vars, fertilizer, crop) {
    const quantity = Game_farmCropMainItemQuantityByQuality(vars, fertilizer, crop);
    const matchValue = crop.ExtraItem;
    if (matchValue == null) {
        return [quantity];
    }
    else {
        return [quantity, new Qualities$1(updateAt(0, matchValue[1] + item_2(0, Qualities_zero.fields[0]), Qualities_zero.fields[0], Float64Array))];
    }
}

export function Game_forageCropMainItemQuantity(vars, crop) {
    return ForageCropModule_xpItemsPerHarvest(vars.Skills) / crop.Foragables.length;
}

export function Game_cropMainItemQuantity(vars, _arg) {
    if (_arg.tag === 1) {
        return Game_forageCropMainItemQuantity(vars, _arg.fields[0]);
    }
    else {
        return Game_farmCropMainItemQuantity(vars, _arg.fields[0]);
    }
}

export function Game_cropMainItemQuantityByQuality(vars, fertilizer, _arg) {
    if (_arg.tag === 1) {
        return Game_forageCropItemQuantityByQuality(vars, _arg.fields[0]);
    }
    else {
        return Game_farmCropMainItemQuantityByQuality(vars, fertilizer, _arg.fields[0]);
    }
}

export function Game_cropItemQuantitiesByQuality(vars, fertilizer, _arg) {
    if (_arg.tag === 1) {
        const crop_1 = _arg.fields[0];
        const value = Game_forageCropItemQuantityByQuality(vars, crop_1);
        const count = crop_1.Foragables.length | 0;
        return fill(new Array(count), 0, count, value);
    }
    else {
        return Game_farmCropItemQuantitiesByQuality(vars, fertilizer, _arg.fields[0]);
    }
}

export function Game_processorUnlocked(data, vars, processor) {
    if (vars.Skills.IgnoreSkillLevelRequirements) {
        return true;
    }
    else {
        return forAll((l) => (l <= vars.Skills.Farming.Level), toArray(Table_tryFind(processor, data.ProcessorUnlockLevel)));
    }
}

export function Game_productUnlocked(data, vars) {
    return (arg) => Game_processorUnlocked(data, vars, ProductModule_processor(arg));
}

export function Game_seedPrice(data, vars, seed, _arg) {
    let value_5;
    if (_arg.tag === 1) {
        const price_2 = defaultArgWith(_arg.fields[1], () => (2 * getItemFromDict(data.Items.fields[0], seed * 1).SellPrice));
        if (_arg.fields[0] === "Joja") {
            const value_2 = (vars.Multipliers.ProfitMargin * (vars.JojaMembership ? 1 : 1.25)) * price_2;
            return value_2 >>> 0;
        }
        else {
            return max(1, (value_5 = (vars.Multipliers.ProfitMargin * price_2), value_5 >>> 0));
        }
    }
    else {
        return _arg.fields[1];
    }
}

export function Game_itemPrice(vars, forage, item, quality) {
    return ItemModule_price(vars.Skills, vars.Multipliers, forage, item, quality);
}

export function Game_itemPriceByQuality(vars, forage, item) {
    return ItemModule_priceByQuality(vars.Skills, vars.Multipliers, forage, item);
}

export function Game_productPriceAndQuality(data, vars, quality, product) {
    return ProductModule_priceAndQuality((key) => getItemFromDict(data.Items.fields[0], key), vars.Skills, vars.Multipliers, vars.QualityArtisanProducts, quality, product);
}

export function Game_productPrice(data, vars, quality, product) {
    return ProductModule_price((key) => getItemFromDict(data.Items.fields[0], key), vars.Skills, vars.Multipliers, vars.QualityArtisanProducts, quality, product);
}

export function Game_productPriceByQuality(data, vars, product) {
    return ProductModule_priceByQuality((key) => getItemFromDict(data.Items.fields[0], key), vars.Skills, vars.Multipliers, vars.QualityArtisanProducts, product);
}

export function Game_productNormalizedPrice(data, vars, quality, product) {
    return ProductModule_normalizedPrice((key) => getItemFromDict(data.Items.fields[0], key), vars.Skills, vars.Multipliers, vars.QualityArtisanProducts, quality, product);
}

export function Game_productNormalizedPriceByQuality(data, vars, product) {
    return ProductModule_normalizedPriceByQuality((key) => getItemFromDict(data.Items.fields[0], key), vars.Skills, vars.Multipliers, vars.QualityArtisanProducts, product);
}

export function Game_productQuality(data, vars, quality, product) {
    return ProductModule_outputQuality((key) => getItemFromDict(data.Items.fields[0], key), vars.QualityArtisanProducts, quality, product);
}

export function Game_seedItemSellPrice(data, vars, seed) {
    return Game_itemPrice(vars, false, getItemFromDict(data.Items.fields[0], seed * 1), 0);
}

export function Game_xpPerItem(data, crop) {
    return CropModule_xpPerItem((key) => getItemFromDict(data.Items.fields[0], key), crop);
}

export function Game_xpItemsPerHarvest(vars, crop) {
    return CropModule_xpItemsPerHarvest(Game_giantCropProb(vars), vars.Skills, crop);
}

export function Game_xpPerHarvest(data, vars, crop) {
    return CropModule_xpPerHarvest((key) => getItemFromDict(data.Items.fields[0], key), Game_giantCropProb(vars), vars.Skills, crop);
}

//# sourceMappingURL=Game.js.map
